import { render, staticRenderFns } from "./assignedTaximeters.vue?vue&type=template&id=71842b3e&scoped=true&"
import script from "./assignedTaximeters.vue?vue&type=script&lang=js&"
export * from "./assignedTaximeters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71842b3e",
  null
  
)

export default component.exports